import _asyncToGenerator from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "C:\\Users\\eric.sangabriel\\Documents\\GitHub\\web\\node_modules\\@babel\\runtime\\regenerator\\index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.object.from-entries.js";
var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _pointerDownTimeStamp, _currentMedia, _handlePointerMove, handlePointerMove_fn, _handlePointerUp, handlePointerUp_fn, _setInactive, setInactive_fn, _setActive, setActive_fn, _scheduleInactive, scheduleInactive_fn;

import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIAttributes, MediaStateChangeEvents } from "./constants.js";
import { nouns } from "./labels/labels.js";
import { observeResize } from "./utils/resize-observer.js";
import "./media-gesture-receiver.js";
var Attributes = {
  AUDIO: "audio",
  AUTOHIDE: "autohide",
  BREAKPOINTS: "breakpoints",
  GESTURES_DISABLED: "gesturesdisabled",
  KEYBOARD_CONTROL: "keyboardcontrol",
  NO_AUTOHIDE: "noautohide",
  USER_INACTIVE: "userinactive"
};
var template = document.createElement("template");
template.innerHTML = "\n  <style>\n    ".concat("\n    :host([", MediaUIAttributes.MEDIA_IS_FULLSCREEN, "]) ::slotted([slot=media]) {\n      outline: none;\n    }\n\n    :host {\n      box-sizing: border-box;\n      position: relative;\n      display: inline-block;\n      line-height: 0;\n      background-color: var(--media-background-color, #000);\n    }\n\n    :host(:not([").concat(Attributes.AUDIO, "])) [part~=layer]:not([part~=media-layer]) {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      display: flex;\n      flex-flow: column nowrap;\n      align-items: start;\n      pointer-events: none;\n      background: none;\n    }\n\n    slot[name=media] {\n      display: var(--media-slot-display, contents);\n    }\n\n    ", "\n    :host([").concat(Attributes.AUDIO, "]) slot[name=media] {\n      display: var(--media-slot-display, none);\n    }\n\n    ", "\n    :host([").concat(Attributes.AUDIO, "]) [part~=layer][part~=gesture-layer] {\n      height: 0;\n      display: block;\n    }\n\n    ", "\n    :host(:not([").concat(Attributes.AUDIO, "])[").concat(Attributes.GESTURES_DISABLED, "]) ::slotted([slot=gestures-chrome]),\n    :host(:not([").concat(Attributes.AUDIO, "])[").concat(Attributes.GESTURES_DISABLED, "]) media-gesture-receiver[slot=gestures-chrome] {\n      display: none;\n    }\n\n    ", "\n    ::slotted(:not([slot=media]):not([slot=poster]):not(media-loading-indicator)) {\n      pointer-events: auto;\n    }\n\n    :host(:not([").concat(Attributes.AUDIO, "])) *[part~=layer][part~=centered-layer] {\n      align-items: center;\n      justify-content: center;\n    }\n\n    :host(:not([").concat(Attributes.AUDIO, "])) ::slotted(media-gesture-receiver[slot=gestures-chrome]),\n    :host(:not([").concat(Attributes.AUDIO, "])) media-gesture-receiver[slot=gestures-chrome] {\n      align-self: stretch;\n      flex-grow: 1;\n    }\n\n    slot[name=middle-chrome] {\n      display: inline;\n      flex-grow: 1;\n      pointer-events: none;\n      background: none;\n    }\n\n    ", "\n    ::slotted([slot=media]),\n    ::slotted([slot=poster]) {\n      width: 100%;\n      height: 100%;\n    }\n\n    ", "\n    :host(:not([").concat(Attributes.AUDIO, "])) .spacer {\n      flex-grow: 1;\n    }\n\n    ", "\n    :host(:-webkit-full-screen) {\n      ", "\n      width: 100% !important;\n      height: 100% !important;\n    }\n\n    ", "\n    ::slotted(:not([slot=media]):not([").concat(Attributes.NO_AUTOHIDE, "])) {\n      opacity: 1;\n      transition: opacity 0.25s;\n    }\n\n    ", "\n    :host([").concat(Attributes.USER_INACTIVE, "]:not([").concat(MediaUIAttributes.MEDIA_PAUSED, "]):not([").concat(MediaUIAttributes.MEDIA_IS_AIRPLAYING, "]):not([").concat(MediaUIAttributes.MEDIA_IS_CASTING, "]):not([").concat(Attributes.AUDIO, "])) ::slotted(:not([slot=media]):not([").concat(Attributes.NO_AUTOHIDE, "])) {\n      opacity: 0;\n      transition: opacity 1s;\n    }\n\n    :host([").concat(Attributes.USER_INACTIVE, "]:not([").concat(MediaUIAttributes.MEDIA_PAUSED, "]):not([").concat(MediaUIAttributes.MEDIA_IS_CASTING, "]):not([").concat(Attributes.AUDIO, "])) ::slotted([slot=media]) {\n      cursor: none;\n    }\n\n    ::slotted(media-control-bar)  {\n      align-self: stretch;\n    }\n\n    ", "\n    :host(:not([").concat(Attributes.AUDIO, "])[").concat(MediaUIAttributes.MEDIA_HAS_PLAYED, "]) slot[name=poster] {\n      display: none;\n    }\n  </style>\n\n  <slot name=\"media\" part=\"layer media-layer\"></slot>\n  <slot name=\"poster\" part=\"layer poster-layer\"></slot>\n  <slot name=\"gestures-chrome\" part=\"layer gesture-layer\">\n    <media-gesture-receiver slot=\"gestures-chrome\"></media-gesture-receiver>\n  </slot>\n  <span part=\"layer vertical-layer\">\n    <slot name=\"top-chrome\" part=\"top chrome\"></slot>\n    <slot name=\"middle-chrome\" part=\"middle chrome\"></slot>\n    <slot name=\"centered-chrome\" part=\"layer centered-layer center centered chrome\"></slot>\n    ", "\n    <slot part=\"bottom chrome\"></slot>\n  </span>\n");
var MEDIA_UI_ATTRIBUTE_NAMES = Object.values(MediaUIAttributes);
var defaultBreakpoints = "sm:384 md:576 lg:768 xl:960";

function resizeCallback(entry) {
  setBreakpoints(entry.target, entry.contentRect.width);
}

function setBreakpoints(container, width) {
  var _a;

  if (!container.isConnected) return;
  var breakpoints = (_a = container.getAttribute(Attributes.BREAKPOINTS)) != null ? _a : defaultBreakpoints;
  var ranges = createBreakpointMap(breakpoints);
  var activeBreakpoints = getBreakpoints(ranges, width);
  var changed = false;
  Object.keys(ranges).forEach(function (name) {
    if (activeBreakpoints.includes(name)) {
      if (!container.hasAttribute("breakpoint".concat(name))) {
        container.setAttribute("breakpoint".concat(name), "");
        changed = true;
      }

      return;
    }

    if (container.hasAttribute("breakpoint".concat(name))) {
      container.removeAttribute("breakpoint".concat(name));
      changed = true;
    }
  });

  if (changed) {
    var evt = new CustomEvent(MediaStateChangeEvents.BREAKPOINTS_CHANGE, {
      detail: activeBreakpoints
    });
    container.dispatchEvent(evt);
  }
}

function createBreakpointMap(breakpoints) {
  var pairs = breakpoints.split(/\s+/);
  return Object.fromEntries(pairs.map(function (pair) {
    return pair.split(":");
  }));
}

function getBreakpoints(breakpoints, width) {
  return Object.keys(breakpoints).filter(function (name) {
    return width >= breakpoints[name];
  });
}

var MediaContainer = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaContainer, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaContainer);

  function MediaContainer() {
    var _this;

    _classCallCheck(this, MediaContainer);

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _handlePointerMove);

    __privateAdd(_assertThisInitialized(_this), _handlePointerUp);

    __privateAdd(_assertThisInitialized(_this), _setInactive);

    __privateAdd(_assertThisInitialized(_this), _setActive);

    __privateAdd(_assertThisInitialized(_this), _scheduleInactive);

    __privateAdd(_assertThisInitialized(_this), _pointerDownTimeStamp, 0);

    __privateAdd(_assertThisInitialized(_this), _currentMedia, void 0);

    __publicField(_assertThisInitialized(_this), "breakpointsComputed", false);

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    var mutationCallback = function mutationCallback(mutationsList) {
      var media = _this.media;

      var _iterator = _createForOfIteratorHelper(mutationsList),
          _step;

      try {
        var _loop = function _loop() {
          var mutation = _step.value;

          if (mutation.type === "childList") {
            mutation.removedNodes.forEach(function (node) {
              if (node.slot == "media" && mutation.target == _assertThisInitialized(_this)) {
                var previousSibling = mutation.previousSibling && mutation.previousSibling.previousElementSibling;

                if (!previousSibling || !media) {
                  _this.mediaUnsetCallback(node);
                } else {
                  var wasFirst = previousSibling.slot !== "media";

                  while ((previousSibling = previousSibling.previousSibling) !== null) {
                    if (previousSibling.slot == "media") wasFirst = false;
                  }

                  if (wasFirst) _this.mediaUnsetCallback(node);
                }
              }
            });

            if (media) {
              mutation.addedNodes.forEach(function (node) {
                if (node === media && media !== __privateGet(_assertThisInitialized(_this), _currentMedia)) {
                  _this.handleMediaUpdated(media).then(function (media2) {
                    return _this.mediaSetCallback(media2);
                  });
                }
              });
            }
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    var mutationObserver = new MutationObserver(mutationCallback);
    mutationObserver.observe(_assertThisInitialized(_this), {
      childList: true,
      subtree: true
    });
    var pendingResizeCb = false;

    var deferResizeCallback = function deferResizeCallback(entry) {
      if (pendingResizeCb) return;
      setTimeout(function () {
        resizeCallback(entry);
        pendingResizeCb = false;

        if (!_this.breakpointsComputed) {
          _this.breakpointsComputed = true;

          _this.dispatchEvent(new CustomEvent(MediaStateChangeEvents.BREAKPOINTS_COMPUTED, {
            bubbles: true,
            composed: true
          }));
        }
      }, 0);
      pendingResizeCb = true;
    };

    observeResize(_assertThisInitialized(_this), deferResizeCallback);

    var chainedSlot = _this.querySelector(":scope > slot[slot=media]");

    if (chainedSlot) {
      chainedSlot.addEventListener("slotchange", function () {
        var slotEls = chainedSlot.assignedElements({
          flatten: true
        });

        if (!slotEls.length) {
          if (__privateGet(_assertThisInitialized(_this), _currentMedia)) {
            _this.mediaUnsetCallback(__privateGet(_assertThisInitialized(_this), _currentMedia));
          }

          return;
        }

        if (_this.media && _this.media !== __privateGet(_assertThisInitialized(_this), _currentMedia)) {
          _this.handleMediaUpdated(_this.media).then(function (media) {
            return _this.mediaSetCallback(media);
          });
        }
      });
    }

    return _this;
  }

  _createClass(MediaContainer, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      if (attrName.toLowerCase() == Attributes.AUTOHIDE) {
        this.autohide = newValue;
      }
    }
  }, {
    key: "media",
    get: function get() {
      var media = this.querySelector(":scope > [slot=media]");
      if ((media == null ? void 0 : media.nodeName) == "SLOT") media = media.assignedElements({
        flatten: true
      })[0];
      return media;
    }
  }, {
    key: "handleMediaUpdated",
    value: function () {
      var _handleMediaUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(media) {
        var _this2 = this;

        var rejectMediaPromise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __privateSet(this, _currentMedia, media);

                rejectMediaPromise = function rejectMediaPromise(media2) {
                  __privateSet(_this2, _currentMedia, null);

                  console.error('Media Chrome: Media element set with slot="media" does not appear to be compatible.', media2);
                  return Promise.reject(media2);
                };

                if (media) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", rejectMediaPromise(media));

              case 4:
                if (!media.localName.includes("-")) {
                  _context.next = 7;
                  break;
                }

                _context.next = 7;
                return globalThis.customElements.whenDefined(media.localName);

              case 7:
                return _context.abrupt("return", media);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleMediaUpdated(_x) {
        return _handleMediaUpdated.apply(this, arguments);
      }

      return handleMediaUpdated;
    }()
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      var _a;

      var isAudioChrome = this.getAttribute(Attributes.AUDIO) != null;
      var label = isAudioChrome ? nouns.AUDIO_PLAYER() : nouns.VIDEO_PLAYER();
      this.setAttribute("role", "region");
      this.setAttribute("aria-label", label);

      if (this.media && this.media !== __privateGet(this, _currentMedia)) {
        this.handleMediaUpdated(this.media).then(function (media) {
          return _this3.mediaSetCallback(media);
        });
      }

      this.setAttribute(Attributes.USER_INACTIVE, "");
      this.addEventListener("pointerdown", this);
      this.addEventListener("pointermove", this);
      this.addEventListener("pointerup", this);
      this.addEventListener("mouseleave", this);
      this.addEventListener("keyup", this);
      (_a = globalThis.window) == null ? void 0 : _a.addEventListener("mouseup", this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a;

      if (this.media) {
        this.mediaUnsetCallback(this.media);
      }

      (_a = globalThis.window) == null ? void 0 : _a.removeEventListener("mouseup", this);
    }
  }, {
    key: "mediaSetCallback",
    value: function mediaSetCallback(media) {}
  }, {
    key: "mediaUnsetCallback",
    value: function mediaUnsetCallback(media) {}
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      switch (event.type) {
        case "pointerdown":
          __privateSet(this, _pointerDownTimeStamp, event.timeStamp);

          break;

        case "pointermove":
          __privateMethod(this, _handlePointerMove, handlePointerMove_fn).call(this, event);

          break;

        case "pointerup":
          __privateMethod(this, _handlePointerUp, handlePointerUp_fn).call(this, event);

          break;

        case "mouseleave":
          __privateMethod(this, _setInactive, setInactive_fn).call(this);

          break;

        case "mouseup":
          this.removeAttribute(Attributes.KEYBOARD_CONTROL);
          break;

        case "keyup":
          __privateMethod(this, _scheduleInactive, scheduleInactive_fn).call(this);

          this.setAttribute(Attributes.KEYBOARD_CONTROL, "");
          break;
      }
    }
  }, {
    key: "autohide",
    get: function get() {
      return this._autohide === void 0 ? 2 : this._autohide;
    },
    set: function set(seconds) {
      seconds = Number(seconds);
      this._autohide = isNaN(seconds) ? 0 : seconds;
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [Attributes.AUTOHIDE, Attributes.GESTURES_DISABLED].concat(MEDIA_UI_ATTRIBUTE_NAMES).filter(function (name) {
        return ![MediaUIAttributes.MEDIA_RENDITION_LIST, MediaUIAttributes.MEDIA_AUDIO_TRACK_LIST].includes(name);
      });
    }
  }]);

  return MediaContainer;
}(globalThis.HTMLElement);

_pointerDownTimeStamp = new WeakMap();
_currentMedia = new WeakMap();
_handlePointerMove = new WeakSet();

handlePointerMove_fn = function handlePointerMove_fn(event) {
  if (event.pointerType !== "mouse") {
    var MAX_TAP_DURATION = 250;
    if (event.timeStamp - __privateGet(this, _pointerDownTimeStamp) < MAX_TAP_DURATION) return;
  }

  __privateMethod(this, _setActive, setActive_fn).call(this);

  clearTimeout(this._inactiveTimeout);

  if ([this, this.media].includes(event.target)) {
    __privateMethod(this, _scheduleInactive, scheduleInactive_fn).call(this);
  }
};

_handlePointerUp = new WeakSet();

handlePointerUp_fn = function handlePointerUp_fn(event) {
  if (event.pointerType === "touch") {
    var controlsVisible = !this.hasAttribute(Attributes.USER_INACTIVE);

    if ([this, this.media].includes(event.target) && controlsVisible) {
      __privateMethod(this, _setInactive, setInactive_fn).call(this);
    } else {
      __privateMethod(this, _scheduleInactive, scheduleInactive_fn).call(this);
    }
  } else if (event.composedPath().some(function (el) {
    return ["media-play-button", "media-fullscreen-button"].includes(el == null ? void 0 : el.localName);
  })) {
    __privateMethod(this, _scheduleInactive, scheduleInactive_fn).call(this);
  }
};

_setInactive = new WeakSet();

setInactive_fn = function setInactive_fn() {
  if (this.autohide < 0) return;
  if (this.hasAttribute(Attributes.USER_INACTIVE)) return;
  this.setAttribute(Attributes.USER_INACTIVE, "");
  var evt = new globalThis.CustomEvent(MediaStateChangeEvents.USER_INACTIVE, {
    composed: true,
    bubbles: true,
    detail: true
  });
  this.dispatchEvent(evt);
};

_setActive = new WeakSet();

setActive_fn = function setActive_fn() {
  if (!this.hasAttribute(Attributes.USER_INACTIVE)) return;
  this.removeAttribute(Attributes.USER_INACTIVE);
  var evt = new globalThis.CustomEvent(MediaStateChangeEvents.USER_INACTIVE, {
    composed: true,
    bubbles: true,
    detail: false
  });
  this.dispatchEvent(evt);
};

_scheduleInactive = new WeakSet();

scheduleInactive_fn = function scheduleInactive_fn() {
  var _this4 = this;

  __privateMethod(this, _setActive, setActive_fn).call(this);

  clearTimeout(this._inactiveTimeout);
  if (this.autohide < 0) return;
  this._inactiveTimeout = setTimeout(function () {
    __privateMethod(_this4, _setInactive, setInactive_fn).call(_this4);
  }, this.autohide * 1e3);
};

var media_container_default = MediaContainer;
export { Attributes, MediaContainer, media_container_default as default };